import { useState, useEffect } from "react";
import InfoTooltip from '../InfoTooltip/InfoTooltip';
import { inventoryHealthService } from "../../../services/inventoryHealthService";
import { numberToKiloFormat } from "../../../utils/utils";
import "./DashboardCard.css";

const DashboardCard = ({viewType, cardData, color,}) => {
    const [healthInfo, setHealthInfo] = useState(null);

    useEffect(() => {
      inventoryHealthService.getHealthInfo()
        .then(response => { if (response) setHealthInfo(response); })
        .catch(() => {});
    }, []);

    return (
        <div className="dashboard-cards-item">
            <div className='dashboard-cards-item-category-header'>
            <div className='dashboard-cards-item-category-heading'>
                <span className='dashboard-cards-item-category-title'>{cardData?.abc_category}</span>
                <div className={`dashboard-cards-item-category-share ${color}`}>
                Доля: {cardData?.sales_share_percent}%
                </div>
            </div>

            <div className='dashboard-cards-item-category-subheading'>
                {cardData?.number_of_skus} СКЮ ({cardData?.percent_of_skus}% от тотала)
            </div>
            </div>

            <div className="dashboard-cards-item-category-body">
            <div className='dashboard-cards-item-category-value'>
                <div className="dashboard-cards-item-category-label">
                Тотал продажи
                </div>
                <div className="dashboard-cards-item-category-number">
                {numberToKiloFormat(cardData?.total_sales_value, { kiloThreshold: 1_000_000 })}  {viewType === "DSP" && "₸"}
                </div>
            </div>
            <div className='dashboard-cards-item-category-value'>
                <div className="dashboard-cards-item-category-label">
                Товарный запас
                </div>
                <div className="dashboard-cards-item-category-number">
                {cardData?.share_of_stock}%
                </div>
            </div>
            <div className='dashboard-cards-item-category-value'>
                <div className="dashboard-cards-item-category-label" 
                    style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 4 
                    }}
                >
                Индекс Здоровья
                {healthInfo && (
                  <InfoTooltip>
                    <div><span style={{ color: '#25A854', fontWeight: 600 }}>Здоровый:</span> {healthInfo.healthy}</div>
                    <div><span style={{ color: '#F59E0B', fontWeight: 600 }}>Нормальный:</span> {healthInfo.normal}</div>
                    <div>
                        <span style={{ color: '#EF4444', fontWeight: 600 }}>
                            Критический:
                        </span> {healthInfo.critical_overstock}. {healthInfo.critical_understock}
                    </div>
                  </InfoTooltip>
                )}
                </div>
                <div className="dashboard-cards-item-category-number">
                {cardData?.category_health_index}
                </div>
            </div>
            </div>
        </div>
    );
};

export default DashboardCard;
